// extracted by mini-css-extract-plugin
export default {"root":"nv9Mc","new":"WJGs0"};